export default __webpack_public_path__ + "static/media/example2.2cd2c063.svg";